import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		//AUDIO CONTEXT IS ACTIVE
		hasAudioContextTriggered:false,
		//IS VOICE CONTROL CURRENTLY ACTIVE
		isVoiceControlled: 		false,
		//DOES BROWSER SUPPORT VOICE CONTROL
		allowSpeechControl: 	false,
		//DOES BROWSER SUPPORT MEDIA RTC
		// allowMediaRecording: false
		//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT
		doNotAddress:           false,
		isFirstLoad:            true,
	}
});


// WEBPACK FOOTER //
// ./src/store/store.js